import * as React from "react"

const LevelSvg = (props) => (
  <svg
    width={22}
    height={25}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        d="M4.939 12.734a1.526 1.526 0 0 1-.888-1.667c.19-1.172.613-2.208 1.247-3.02.845-1.08 1.986-1.667 3.232-1.667 1.247 0 2.387.586 3.232 1.668.634.81 1.057 1.847 1.247 2.996.106.721-.254 1.42-.887 1.667-.888.36-2.219.789-3.592.789-1.458 0-2.746-.405-3.591-.766Z"
        fill="#F93D92"
      />
      <path
        d="m4.545 11.147-.002.009c-.085.47.174.94.592 1.118.806.344 2.026.726 3.395.726 1.28 0 2.54-.401 3.403-.752l.007-.002c.384-.15.65-.6.575-1.125-.18-1.08-.574-2.032-1.147-2.765-.76-.974-1.761-1.476-2.838-1.476-1.077 0-2.078.502-2.838 1.476-.574.733-.968 1.687-1.147 2.79Z"
        stroke="#FFFBE6"
        strokeOpacity={0.25}
      />
      <path
        d="m9.615 1.358-.005-.003A1.796 1.796 0 0 0 8.53 1c-.416 0-.82.143-1.142.377l-.005.004c-.151.108-.31.257-.431.405l-.005.006c-.32.378-.515.892-.515 1.48 0 1.286.968 2.27 2.098 2.27 1.123 0 2.078-.998 2.078-2.27 0-.603-.211-1.134-.546-1.51a3.016 3.016 0 0 0-.448-.404Z"
        fill="#5675D3"
        stroke="#5675D3"
      />
      <path
        d="M7.116 3.654a.246.246 0 0 0-.233.338c.212.766.867 1.33 1.67 1.33.781 0 1.457-.564 1.668-1.33.043-.158-.084-.338-.232-.338H7.116Z"
        fill="#E5E5E5"
      />
      <path
        d="M6.588 1.469c.19.225.422.428.697.586.063.022.105.067.169.09.126.045.253.09.359.135.317.09.634.113.95.09a2.18 2.18 0 0 0 .634-.158c.043-.022.085-.022.106-.045.106-.045.19-.112.296-.157a3.08 3.08 0 0 0 .676-.609 3.53 3.53 0 0 0-.528-.473c-.085.113-.19.225-.317.316-.021.022-.19.135-.254.157-.76.36-1.69.203-2.26-.428-.212.135-.38.293-.528.496Z"
        fill="#F9D628"
      />
    </g>
    <g clipPath="url(#b)" fill="#5675D3">
      <path d="M1.105 23.546c.506.5 1.327.5 1.833 0a1.27 1.27 0 0 0 0-1.812c-.506-.5-1.327-.5-1.833 0a1.27 1.27 0 0 0 0 1.812ZM7.064 17.658c.506.5 1.327.5 1.833 0a1.27 1.27 0 0 0 0-1.812c-.506-.5-1.327-.5-1.833 0a1.27 1.27 0 0 0 0 1.812ZM6.605 17.809 3.091 21.28l.306.302 3.514-3.472-.306-.302ZM13.048 21.576c.507.5 1.327.5 1.834 0a1.27 1.27 0 0 0 0-1.812c-.507-.5-1.327-.5-1.834 0a1.27 1.27 0 0 0 0 1.812ZM19.007 15.688c.506.5 1.327.5 1.833 0a1.27 1.27 0 0 0 0-1.812c-.506-.5-1.327-.5-1.833 0a1.27 1.27 0 0 0 0 1.812ZM18.549 15.84l-3.515 3.471.306.302 3.514-3.472-.305-.302ZM11.83 20.234 9.54 17.97l.305-.302 2.292 2.264-.306.302Z" />
    </g>
    <defs>
      <clipPath id="a">
        <path
          fill="#fff"
          transform="matrix(-1 0 0 1 13.031 .5)"
          d="M0 0h9v13H0z"
        />
      </clipPath>
      <clipPath id="b">
        <path
          fill="#fff"
          transform="translate(.031 12.97)"
          d="M0 0h21.823v11.529H0z"
        />
      </clipPath>
    </defs>
  </svg>
)

export default LevelSvg
